<template>
<bim-row id="what-you-get" class="services-lending__privilege-container" justify="center">
  <bim-col class="services-lending__info-title" cols="12">Вы получите:</bim-col>

  <bim-row justify="center">
    <bim-col 
      v-for="(privilege, index) in privileges"
      :key="index"
      class="privilege-item__text" 
      cols="12"
      sm="6"
      lg="4"
    >
      <img class="privilege-item__text-img" :src="privilege.img" alt="" />
      <h2 class="text-brief">{{ privilege.text }}</h2>
    </bim-col>
  </bim-row>

  <bim-col class="privilege-brief" cols="12" sm="9">Вам станет доступна информация о потребностях на строительной площадке и контактныe данныe ответственных лиц</bim-col>
</bim-row>
</template>

<script>
import bimRow from '@bimlib/components/bimRow'
import bimCol from '@bimlib/components/bimCol'

export default {
  components: {
    bimCol,
    bimRow
  },

  data() {
    return {
      privileges: [
        {
          img: "/dist/assets/front_white/img/services_lending/privilege/objects.svg",
          text: "Все объекты в одном месте"
        },
        {
          img: "/dist/assets/front_white/img/services_lending/privilege/contacts.svg",
          text: "Контактные данные"
        },
        {
          img: "/dist/assets/front_white/img/services_lending/privilege/info.svg",
          text: "Информацию о проектной потребности"
        }
      ]
    }
  }
}
</script>